import { derinApiClient } from "./setup";
import { DerinApiResponse, MergeGroup, UserMergePreview, UserMergeResult } from "./interface";

/** Alias groups to merge and the cases that need a decision. Read-only. */
export const getUserMergePreview = async (): Promise<UserMergePreview> => {
  const response = await derinApiClient().get<DerinApiResponse<UserMergePreview>>(
    "/migration/users/merge"
  );
  return response.data.data;
};

/** Merges the approved groups. A group that changed since the preview comes back skipped. */
export const mergeUserGroups = async (groups: MergeGroup[]): Promise<UserMergeResult> => {
  const response = await derinApiClient().post<DerinApiResponse<UserMergeResult>>(
    "/migration/users/merge",
    { groups: groups.map(({ canonical, userIds }) => ({ canonical, userIds })) }
  );
  return response.data.data;
};

/** Merges accounts into the one picked, which keeps its own email. */
export const mergeUsersInto = async (
  intoUserId: string,
  mergeUserIds: string[]
): Promise<UserMergeResult> => {
  const response = await derinApiClient().post<DerinApiResponse<UserMergeResult>>(
    "/migration/users/merge/explicit",
    { intoUserId, mergeUserIds }
  );
  return response.data.data;
};

/** Drops the +tag from a lone alias account's email. */
export const applyCanonicalEmail = async (
  userId: string
): Promise<{ id: string; email: string }> => {
  const response = await derinApiClient().post<DerinApiResponse<{ id: string; email: string }>>(
    `/migration/users/${userId}/canonical-email`
  );
  return response.data.data;
};
